import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export default lazyLoadComponentFactory(() => import("./page-load-processor"));
